import React, { useState } from 'react'
import { Card,Input,Button, notification, Spin } from 'antd';
import { QuestionCircleOutlined  } from '@ant-design/icons';
import {Row,Col} from 'react-bootstrap';
import { baseURL } from '../store/api/axios';
import { encryptdata } from '../utils/encryptDecrypt';

const { TextArea } = Input;

const Helpdesk = () => {
  const [queryText, setQueryText] = useState('')
  const [isLoading, setIsLoading] = useState(false); 
  const userId = parseInt(localStorage.getItem('userId'), 10)
  const rawUserEmail = localStorage.getItem("email"); 
  const userEmail = rawUserEmail.replace(/^"|"$/g, ""); 
  const userName = localStorage.getItem('name')

  const handleChange = async ()=>{
    if (!queryText.trim()) {
      notification.error({
        message: "Validation Error",
        description: "Query cannot be empty or just spaces.",
      });
      return; 
    }
    setIsLoading(true); 

    const payload =  {
        userId: userId,
        email: userEmail,
        textcontent: queryText.trim()
    }

    try {
      const encrypt = encryptdata(payload)
      const response = await fetch(`${baseURL}user/helpdesksendmail`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(encrypt),
        }
      );
    
      if (response.ok) {
        const data = await response.json();
        setQueryText(""); 
        notification.success({
          message: "Success",
          description: "Your query has been submitted successfully!",
        });
      } else {
        const errorData = await response.json(); 
        notification.error({
          message: "Error",
          description: errorData.message || "Failed to submit your query.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Network Error",
        description: "An error occurred while submitting your query. Please try again later.",
      });
      console.error("Error:", error);
    } finally{
      setIsLoading(false)
    }
    
  }


  return (
    <div className='container'>
      <Card title={<QuestionCircleOutlined/>} style={{ width: '100%' }}>
        <Row>
          <Col md={6}>
              <h4 className='mb-4' style={{fontWeight: 'bolder'}}>Help Desk Support</h4>
              <ul>
                <li style={{marginBottom:'10px', color:'#4e4e4e'}}>How to Get Leads? – Recharge your account and access verified leads instantly.</li>
                <li style={{marginBottom:'10px', color:'#4e4e4e'}}>Managing Your Leads – Filter, sort, and track lead status in your dashboard.</li>
                <li style={{marginBottom:'10px', color:'#4e4e4e'}}>Payment & Recharge – Select a plan, recharge, and receive leads based on your package.</li>
                <li style={{marginBottom:'10px', color:'#4e4e4e'}}>Lead Quality Assurance – Our system ensures verified and high-converting leads.</li>
                <li style={{marginBottom:'10px', color:'#4e4e4e'}}>Troubleshooting Issues – Reset password via email, clear cache for login issues, retry payment with another method, or contact support for further help..</li>
                <li style={{marginBottom:'10px', color:'#4e4e4e'}}>Customer Support – Contact our team for assistance via chat, email, or phone.
                  {/* ➕ */}
                  </li>
              </ul>
          </Col>
          <Col md={6}>
              <h6 className='mt-4 mb-3' >Drop your query</h6>
              <Input value={userName} disabled size="large" style={{marginBottom:'10px'}}  />
              <Input value={userEmail} disabled size="large" style={{marginBottom:'10px'}}  />
              <TextArea value={queryText} onChange={(e) => setQueryText(e.target.value)}
                placeholder="Enter your query"
                autoSize={{ minRows: 6,  maxRows: 10, }}/>
                {isLoading ? (
                   <Spin style={{ margin: "20px auto", display: "block" }} />
                ) : (
                  <Button onClick={handleChange} type="primary" style={{width:'100%', marginTop:'20px', height:'40px'}}>Submit Query</Button>
                )}
          </Col>
        </Row>
      </Card>
    </div>
  )
}

export default Helpdesk